import { Clock, AlertTriangle } from "lucide-react";

interface Subscription {
  plan: string;
  status: string;
  trial_end?: string | null;
  trial_days_remaining?: number | null;
  is_trial?: boolean;
  is_expired?: boolean;
}

export function TrialBanner({ subscription }: { subscription: Subscription | null | undefined }) {
  if (!subscription || !subscription.is_trial) return null;

  const days = subscription.trial_days_remaining ?? 0;
  if (days > 7) return null;

  const isExpired = subscription.is_expired;
  const bg = isExpired ? "bg-danger/10 border-danger/30 text-danger" : "bg-amber-50 border-amber-200 text-amber-800";

  return (
    <div className={`border ${bg} px-4 py-2.5 text-[13px] font-medium flex items-center gap-2`}>
      {isExpired ? <AlertTriangle className="w-4 h-4 shrink-0" /> : <Clock className="w-4 h-4 shrink-0" />}
      {isExpired ? (
        <span>Prøveperioden er utløpt. Kontakt support for å aktivere abonnementet.</span>
      ) : (
        <span>
          Prøveperiode utløper om <strong>{days} {days === 1 ? "dag" : "dager"}</strong>. Kontakt support for å fortsette.
        </span>
      )}
    </div>
  );
}

export function TrialExpiredBlock({ subscription }: { subscription: Subscription | null | undefined }) {
  if (!subscription?.is_expired) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 bg-danger/10 text-danger rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertTriangle className="w-8 h-8" />
        </div>
        <h2 className="text-xl font-bold text-ink-900 mb-2">Prøveperioden er utløpt</h2>
        <p className="text-[13px] text-ink-500 mb-6">
          Din prøveperiode på Contrack er utløpt. Kontakt support for å fortsette å bruke systemet.
        </p>
        <a
          href="mailto:support@contrack.ai"
          className="inline-block px-5 py-2.5 bg-brand-600 text-white rounded-xl text-[13px] font-semibold hover:bg-brand-700"
        >
          Kontakt support
        </a>
      </div>
    </div>
  );
}
